export default `float s = 1.;
    for(int j=0;j<7;j++)
      p=mod(p-1.,2.)-1.,
      p*=1.2, s*=1.2,
      p=abs(abs(p)-1.)-1.;
    return (length(cross(p,normalize(vec3(2.0,2.03,1.0))))/s)-0.02;
  }`